import React from 'react';
import { PreviewLinkButton } from '../admin/PreviewLinkButton';

const AdvisorCard = ({ advisor, onCopyUrl, onRegenerate, onDelete, copiedUrl, confirmDelete, setConfirmDelete }) => (
  <div key={advisor.advisor_id} className="bg-gray-700/50 rounded-lg p-4 border border-gray-600">
    <div className="flex items-start justify-between">
      <AdvisorInfo advisor={advisor} />
      <AdvisorActions
        advisor={advisor}
        onCopyUrl={onCopyUrl}
        onRegenerate={onRegenerate}
        onDelete={onDelete}
        copiedUrl={copiedUrl}
        confirmDelete={confirmDelete}
        setConfirmDelete={setConfirmDelete}
      />
    </div>
  </div>
);

const AdvisorInfo = ({ advisor }) => {
  const STATUS_COLORS = {
    active: 'bg-green-500/20 text-green-400 border-green-500/40',
    expired: 'bg-red-500/20 text-red-400 border-red-500/40',
    no_token: 'bg-gray-500/20 text-gray-400 border-gray-500/40',
  };
  const STATUS_LABELS = { active: 'Active', expired: 'Expired' };

  return (
    <div className="flex-1">
      <div className="flex items-center gap-3 mb-1">
        <h4 className="text-white font-semibold">{advisor.name}</h4>
        <span className={`px-2 py-1 rounded-full text-xs font-medium border ${STATUS_COLORS[advisor.token_status] || STATUS_COLORS.no_token}`}>
          {STATUS_LABELS[advisor.token_status] || 'No Token'}
        </span>
      </div>
      <p className="text-sm text-gray-400">{advisor.email}</p>
      {advisor.company && <p className="text-sm text-gray-500">{advisor.company}</p>}
      <div className="flex items-center gap-4 mt-2 text-xs text-gray-500">
        <span>Introductions: {advisor.total_introductions} total / {advisor.weekly_introductions} this week</span>
        {advisor.token_expires && (
          <span>Token expires: {new Date(advisor.token_expires).toLocaleDateString()}</span>
        )}
      </div>
    </div>
  );
};

const AdvisorActions = ({ advisor, onCopyUrl, onRegenerate, onDelete, copiedUrl, confirmDelete, setConfirmDelete }) => (
  <div className="flex items-center gap-2 ml-4">
    {advisor.portal_url && (
      <button onClick={() => onCopyUrl(advisor.portal_url)} data-testid={`copy-url-${advisor.advisor_id}`}
        className="px-3 py-1.5 bg-gray-600 hover:bg-gray-500 text-white rounded text-xs transition">
        {copiedUrl === advisor.portal_url ? 'Copied!' : 'Copy Link'}
      </button>
    )}
    <button onClick={() => onRegenerate(advisor.advisor_id)} data-testid={`regen-token-${advisor.advisor_id}`}
      className="px-3 py-1.5 bg-blue-600 hover:bg-blue-500 text-white rounded text-xs transition">
      Regenerate Token
    </button>
    <PreviewLinkButton
      endpoint={`/api/admin/advisors/${advisor.advisor_id}/preview-link`}
      label="Preview as Trusted Professional"
      testIdSuffix={`adv-${advisor.advisor_id}`}
    />
    {confirmDelete === advisor.advisor_id ? (
      <div className="flex gap-1">
        <button onClick={() => onDelete(advisor.advisor_id)} className="px-3 py-1.5 bg-red-600 hover:bg-red-500 text-white rounded text-xs transition">Confirm</button>
        <button onClick={() => setConfirmDelete(null)} className="px-3 py-1.5 bg-gray-600 hover:bg-gray-500 text-white rounded text-xs transition">Cancel</button>
      </div>
    ) : (
      <button onClick={() => setConfirmDelete(advisor.advisor_id)} data-testid={`remove-${advisor.advisor_id}`}
        className="px-3 py-1.5 bg-red-600/20 hover:bg-red-600 text-red-400 hover:text-white rounded text-xs transition border border-red-600/40">
        Remove
      </button>
    )}
  </div>
);

export default AdvisorCard;
